import React, { useRef, useState } from "react";
import styles from "./styles.module.scss";
import PlaceholderImageCircleIcon from "../../assets/svg/icons/common/placeholder-image-circle";

const ImageUpload = ({
  onImageSelect,
  onImageRemove,
  currentImage = null,
  subText = "high quality image",
  accept = "image/*",
  disabled = false,
}) => {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleFileSelect = (file) => {
    if (file && file.type.startsWith("image/")) {
      onImageSelect(file);
    }
  };

  const handleInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFileSelect(file);
    }
    event.target.value = "";
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragOver(false);

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelect(files[0]);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleClick = () => {
    if (!disabled) {
      fileInputRef.current?.click();
    }
  };

  const getImageSrc = () => {
    if (currentImage) {
      if (typeof currentImage === "string") {
        return currentImage;
      }
      if (currentImage instanceof File) {
        return URL.createObjectURL(currentImage);
      }
      if (currentImage.url) {
        return currentImage.url;
      }
    }
    return null;
  };

  const selectedImage = getImageSrc();

  return (
    <div className={styles.imageUploadAreaContainer}>
      <div
        className={`${styles.uploadArea} ${isDragOver ? styles.dragOver : ""} ${
          disabled ? styles.disabled : ""
        } ${selectedImage ? styles.hasImage : ""}`}
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          onChange={handleInputChange}
          className={styles.fileInput}
          disabled={disabled}
        />

        {selectedImage ? (
          <>
            <div className={styles.imagePreviewContainer}>
              <img
                src={selectedImage}
                alt="Preview"
                className={styles.previewImage}
              />
            </div>
          </>
        ) : (
          <div className={styles.uploadContent}>
            <div className={styles.uploadIcon}>
              <PlaceholderImageCircleIcon />
            </div>
            <div className={styles.uploadText}>
              <p className={styles.placeholder}>
                Upload Photo by drag and drop or{" "}
                <span className={styles.clickToUpload}>click to upload</span>
              </p>
              <p className={styles.subText}>{subText}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
